import { Icons } from 'bold-ui'

export type RastreamentosModel = {
  id: ID
  titulo: string
  estratificacao: EstratificacaoRastreamentoEnum
  identificadoPor?: string
  tooltipText?: string
}

export enum EstratificacaoRastreamentoEnum {
  BAIXO_RISCO = 'Baixo',
  MODERADO_RISCO = 'Moderado',
  ALTO_RISCO = 'Alto',
  MUITO_ALTO_RISCO = 'Muito Alto',
}

export enum RastreamentosTypesEnum {
  RISCO_CARDIOVASCULAR = 'Risco cardiovascular',
}

export enum RastreamentosIdentificadoPorEnum {
  SDC = 'Identificado via SDC',
}

export enum RastreamentosTooltipIdentificadoPorEnum {
  SDC = 'O Suporte à Decisão Clínica identifica riscos com base nos dados do prontuário.',
}

export enum AlertasSdcRiscoCardiovascularEnum {
  MUITO_ALTO_RISCO = 'ALERTA_RISCO_CARDIOVASCULAR_MUITO_ALTO_RISCO',
  ALTO_RISCO = 'ALERTA_RISCO_CARDIOVASCULAR_ALTO_RISCO',
}

export const tipoRastreamentoIconRecord: Record<RastreamentosTypesEnum, Icons> = {
  [RastreamentosTypesEnum.RISCO_CARDIOVASCULAR]: 'heartRateFilled',
}
